export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Champs du formulaire N°"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID requis manquant"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous êtes connecté avec succès, continuez vos opérations au guichet automatique"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuer les transactions aux guichets automatiques"])}
}